import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Atoms, Charts } from 'components';
import { getPfamDomain } from 'api/fetch_data';

class IvalPfamDomain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            plotData: []
        };
        this.header = [
            { key: 'PfamId', content: 'Pfam' },
            { key: 'PfamType', content: 'Pfam type' },
            { key: 'PfamName', content: 'Name' },
            { key: 'start', content: 'Start' },
            { key: 'end', content: 'End' },
            { key: 'evalue', content: 'E-value' },
            { key: 'score', content: 'Score' },
            { key: 'search', content: 'Search same domain gene' }
        ];
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        this.__ignoreLastFetch = true;
    }

    fetchData = () => {
        const { genomeAbbr, id, recordType } = this.props;
        getPfamDomain(genomeAbbr, id, recordType).then(data => {
            if (!this.__ignoreLastFetch) {
                const dataSource = data.map(item => ({
                    PfamId: <a href={`http://pfam.xfam.org/family/${item['PfamId']}`}>{item['PfamId']}</a>,
                    PfamType: item['PfamType'],
                    PfamName: item['PfamName'],
                    start: item['start'],
                    end: item['end'],
                    evalue: item['evalue'],
                    score: item['score'],
                    search: <Link to={{
                        pathname: '/search/pfam_domain',
                        state: {'searchText': item['PfamId'], "species": "All", "genome": "All", "assemble": "All"}
                    }}>Search</Link>
                }));
                const plotData = data.map(item => ({
                    group: item['PfamType'],
                    start: item['start'],
                    end: item['end'],
                    strand: item['strand'],
                    name: item['PfamName'],
                    blocks: [[item['start'], item['end']]],
                }));
                this.setState({ dataSource, plotData});
            }
        });       
       
    };

    render() {
        const { ival, recordType }  = this.props;
        const { dataSource, plotData } = this.state; 

        if (dataSource.length === 0){
            return null;
        }

        const edix = {
            'Trans':ival.exon_len,
            'Prot': ival.aa_num
        };

        return (
            <Atoms.ExpansionInfoCard
                title="Pfam domain"
                mainContent={
                    <Charts.GeneStructure
                        bpStart={0}
                        bpEnd={edix[recordType]}
                        heightPerDataGroup={20}
                        width={1000}
                        padding={[10, 50, 30, 150]}
                        dataSource={plotData}
                    />
                }
                expansionContent={
                    <Atoms.CustomTable 
                        columns={this.header}
                        dataSource={dataSource} />
                }
            />
        );
    }
}

IvalPfamDomain.propTypes = {
    ival: PropTypes.object,
    genomeAbbr: PropTypes.string,
    speciesAbbr: PropTypes.string,
    id: PropTypes.string,
    recordType: PropTypes.string
};

export default IvalPfamDomain;

